import React, { useEffect } from 'react';
import IvoriMethodLnatPage from '../../features/method/IvoriMethodLnatPage';

export default function IvoriMethodLnatRoute() {
  useEffect(() => {
    document.title = "The IVORI Method — Oxford Tutorial & Harvard Case Method | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <IvoriMethodLnatPage />;
}